import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';



const LayoutComponent = ({ children }) => {
	return (
		<>
			<Header/>
			{ children }
			<Footer />
		</>
	);
};
export default LayoutComponent;
